import { Skeleton, Text } from '@mantine/core';
import { IconAt, IconExternalLink } from '@tabler/icons';
import validator from 'validator';
import BookitupTextInput from '../../../Atoms/inputs/BookitupTextInput';
import { useEmailAccountingConfig } from '../../../Service/hooks/useEmailAccountingConfig';
import PanePaper from '../../../Molecules/PanePaper';

const AccountableConfig = () => {
  const { loading, config, email, update } = useEmailAccountingConfig();
  const URL = 'https://help.accountable.eu/en/articles/3664822-add-invoices-from-e-mail';

  return (
    <PanePaper title="Rechnung per E-Mail importieren">
      {loading && <Skeleton height={40} width={600} />}
      {config && (
        <>
          <BookitupTextInput
            icon={<IconAt size={20} />}
            placeholder="address@accounting.de"
            label="E-Mail"
            defaultValue={email ?? undefined}
            type="email"
            onBlurSave={update}
            validate={validator.isEmail}
            errorMessage="Die E-Mail-Adresse ist ungültig."
            sx={{ maxWidth: 600 }}
          />
          <Text mt="xs">
            Nach aktuellem Stand, brauchst du oben nur die E-Mail 'revenue@accountable.eu' eintragen und sicherstellen, dass dein Accountable Konto unter der selben E-Mail-Adresse läuft, wie du sie beim Ausgangsserver eingetragen hast. Falls diese abweicht, könntest du z.B. auch die E-Mail-Adresse in deinem Accountable-Konto anpassen.
            Unter folgender URL findest du aber auch einen Hilfeartikel von Accountable:
            <Text variant="link" color="blue" mt={5} sx={{}}>
              <IconExternalLink style={{ marginBottom: 4, marginRight: 4 }} size={16} />
              <a target="_blank" href={URL} style={{ color: '#1D5191' }}>
                {URL}
              </a>
            </Text>
          </Text>
        </>
      )}
    </PanePaper>
  );
};

export default AccountableConfig;
